import React ,{useRef,useEffect,useState}from "react";
import photo1 from '../../assets/IMG_3665.JPG'
import photo2 from '../../assets/SB5.jpg'
import photo3 from '../../assets/SB11.jpg'
import photo4 from '../../assets/IMG_3706.JPG'
import afterImage from '../../assets/SB8.jpg'
import beforeImage from '../../assets/treeS.jpg'
import treeLogo from '../../assets/cultivation.png'
import waterLogo from '../../assets/water-conservation.png'
import workshopLogo from '../../assets/training.png'
import plantLogo from '../../assets/leaves.png'
import news1 from '../../assets/new-cutting/news1.jpeg'
import news2 from '../../assets/new-cutting/news2.jpeg'
import news3 from '../../assets/new-cutting/news3.jpeg'
import news4 from '../../assets/new-cutting/news4.jpeg'
import news5 from '../../assets/new-cutting/news5.jpeg'
import visionMissionImage from '../../assets/IMG_3665.JPG'
import gandhiSculptureImage from '../../assets/gsp.png'
import shantistal from '../../assets/shantistal.JPG'
import '../Home/Home.css'
import Initiatives from "../Initiative/Initiative";


function Home(){
     
  const treesRef = useRef(null);
  const plantsRef = useRef(null);
  const workRef=useRef(null);
  const waterRef=useRef(null);

  const [countStarted, setCountStarted] = useState(false);

  const animateValue = (ref, end, duration) => {
    let start = 0;
    const increment = end / (duration / 10);  
    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(counter);
        start = end;
      }
      if(end===10){
        ref.current.textContent=`${Math.floor(start).toLocaleString()} Crore+`;
      }else{
        ref.current.textContent = `${Math.floor(start).toLocaleString()}+`;
      }
    
     }, 10);
  };

    useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !countStarted) {
        setCountStarted(true);
        animateValue(treesRef, 100000, 2000); 
        animateValue(plantsRef, 60, 2000);    
        animateValue(workRef,30,2000);
        animateValue(waterRef,10,2000);
      }
    }, options);

    const statsSection = document.querySelector('.key-stats');
    observer.observe(statsSection);

    return () => {
      observer.disconnect();
    };
  }, [countStarted])

  // const scrollRef = useRef(null);

  // const scrollLeft = () => {
  //   scrollRef.current.scrollBy({
  //     left: -300, // Adjust the scroll distance as needed
  //     behavior: "smooth",
  //   });
  // };

  // const scrollRight = () => {
  //   scrollRef.current.scrollBy({
  //     left: 300, // Adjust the scroll distance as needed
  //     behavior: "smooth",
  //   });
  // };
   
  useEffect(() => {
    const sliderRange = document.querySelector(".slider-range");
    const afterImage = document.querySelector(".after-image");
  
    sliderRange.addEventListener("input", (event) => {
      const value = event.target.value;
      afterImage.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    });
  
    return () => {
      sliderRange.removeEventListener("input", () => {});
    };
  }, []);
  
    return(
        <>
        <section class="hero-section">
        <div className="slide" style={{ backgroundImage: `url(${photo1})`}}></div>
            <div className="slide" style={{ backgroundImage: `url(${photo2})`}}></div>
            <div className="slide" style={{ backgroundImage: `url(${photo3})`}}></div>
            <div className="slide" style={{ backgroundImage: `url(${photo4})`}}></div>
            <div class="hero-content">
                <h1>Sowing the Seeds of Sustainability</h1>
                <p>Join us in our mission to conserve nature and uplift communities.</p>
            </div>
        </section>
        <section className="why-salaiban">
              <h2>Why "Salaiban"?</h2>
                <p>
                The project derives its name from the Salai tree (<i>Boswellia serrata</i>), 
                a species native to the Satpura forests and renowned for its medicinal properties. 
                The Salai tree symbolizes the forest’s ecological importance and serves as a focal point 
                for conservation efforts.
                </p>
         </section>
        
        <section className="before-after-section">
            <h2>Ecological Renewal Since 2015</h2>
            <div className="slider-container">
              <div className="slider">
                <img src={beforeImage} alt="Before: Barren Land" className="before-image" />
                <img src={afterImage} alt="After: Greenery" className="after-image" />
                <input type="range" className="slider-range" min="0" max="100" defaultValue="50" />
              </div>
            </div>
        </section>
        <section className="vision-mission-section">
            <div className="vision-mission-content">
                <div className="vision-mission-image">
                <img src={visionMissionImage} alt="Vision and Mission" />
                </div>
                <div className="vision-mission-text">
                <h2>Vision</h2>
                <p>
                    Our vision is to create a sustainable future by conserving nature and fostering harmony between humanity and the environment.
                </p>
                <h2>Mission</h2>
                <p>
                    Our mission is to plant millions of trees, educate communities on conservation, and protect biodiversity for generations to come.
                </p>
                </div>
            </div>
        </section>
        <h2 className="impact-title">Some <span>Impact</span></h2>
        <section className="key-stats">
            <div className="stat">
            <img src={treeLogo} alt="Tree Plantation Logo" className="stat-logo" />
            <h3 ref={treesRef} className="stat-number">0</h3>
            <p>Trees Planted</p>
            </div>
            <div className="stat">
            <img src={plantLogo} alt="Rare Medicinal Plants Logo" className="stat-logo" />
            <h3 ref={plantsRef} className="stat-number">0</h3>
            <p>Rare Medicinal Plants Protected</p>
            </div>
            <div className="stat">
            <img src={workshopLogo} alt="Workshops Conducted Logo" className="stat-logo" />
            <h3 ref={workRef} className="stat-number">0</h3>
            <p>Workshop Conducted Sucessfully!</p>
            </div>
            <div className="stat">
            <img src={waterLogo} alt="Water Conservation Logo" className="stat-logo" />
            <h3 ref={waterRef} className="stat-number">0</h3>
            <p>Liter Water Conservation</p>
            </div>
        </section>
     <Initiatives />   
     <section className="gandhi-sculpture-section">
        <h2 className="section-title">Gandhi’s Peace Sculpture: A Tribute to His Vision</h2>
        <div className="sculpture-content">
          <div className="sculpture-image">
            <img src={gandhiSculptureImage} alt="Gandhi Peace Sculpture" />
            <img src={shantistal} alt="Gandhi Peace Sculpture" />
          </div>
          <div className="sculpture-text">
            <p>
              To commemorate <b>Mahatma Gandhi's</b> 150th birth anniversary, the Tarunai Foundation created the world’s first anamorphic sculpture of Gandhi, the <b>"Peace Sculpture".</b> This remarkable artwork uses illusion art to reveal Gandhi’s image when viewed from specific angles, while appearing as metallic strips from other perspectives.
            </p>
            <p>
              Inspired by Nelson Mandela’s iconic sculpture in South Africa, this unique installation was completed in March 2019 through a month-long effort involving Tarunai volunteers and tribal community members. Built entirely without mechanical assistance, the sculpture features meticulously crafted steel strips.
            </p>
            <p>
              Designed and constructed by <b>Rajendra Kolhe</b>, Secretary of the Tarunai Foundation, the sculpture symbolizes Gandhi’s enduring principles. The site highlights values such as nationalism, environmental conservation, Indian lifestyle, spirituality, making it a hub for inspiration and reflection.
            </p>
            <p>
              This artistic marvel not only honors Gandhi’s legacy but also encourages visitors to embrace his timeless teachings in everyday life.
            </p>
          </div>
        </div>
      </section>
      <section className="videos">
        <h2>Our Videos</h2>
        <div className="video-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/aRLIccTQq9k?si=m-5BRz20rf8EuS_w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/c4EdFRDYdrQ?si=EnUpio_yQjCjmD6l" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </section>

     <section className="news-section">
        <h2 className="news-title">Our Work in the News</h2>
        <div className="news-grid">
          <div className="news-item">
            <img src={news1} alt="News Cutting 1" />
          </div>
          <div className="news-item">
            <img src={news2} alt="News Cutting 2" />
          </div>
          <div className="news-item">
            <img src={news3} alt="News Cutting 3" />
          </div>
          <div className="news-item">
            <img src={news4} alt="News Cutting 4" />
          </div>
          <div className="news-item">
            <img src={news5} alt="News Cutting 5" />
          </div>
        </div>
      </section>
    </>
    )
}

export default Home;